import { useEffect } from 'react';

const STORAGE_KEY = 'bpm_cookie_consent';
const POSTHOG_KEY = 'phc_xAvL2Iq4tFmANRE7kzbKwaSqp1HJjN7x48s3vr0CMjs';
// EU host for GDPR compliance
const POSTHOG_HOST = 'https://eu.i.posthog.com';

const POSTHOG_INIT_FLAG = '__bpm_posthog_initialized';

// Google Analytics 4 (gtag.js)
const GA_MEASUREMENT_ID = 'G-YJ6CFJC3BR';
const GA_INIT_FLAG = '__bpm_ga4_initialized';

/**
 * Loads and initializes PostHog ONLY when the user has granted analytics consent.
 * Reads consent from localStorage 'bpm_cookie_consent'. Re-evaluates on
 * 'bpm-consent-changed' event (fired by CookieBanner) and on cross-tab 'storage' events.
 */
function loadPostHog() {
  if (typeof window === 'undefined') return;
  if (window[POSTHOG_INIT_FLAG]) return;

  // PostHog snippet (official, minimal)
  /* eslint-disable */
  !function(t,e){var o,n,p,r;e.__SV||(window.posthog=e,e._i=[],e.init=function(i,s,a){function g(t,e){var o=e.split(".");2==o.length&&(t=t[o[0]],e=o[1]),t[e]=function(){t.push([e].concat(Array.prototype.slice.call(arguments,0)))}}(p=t.createElement("script")).type="text/javascript",p.crossOrigin="anonymous",p.async=!0,p.src=s.api_host.replace(".i.posthog.com","-assets.i.posthog.com")+"/static/array.js",(r=t.getElementsByTagName("script")[0]).parentNode.insertBefore(p,r);var u=e;for(void 0!==a?u=e[a]=[]:a="posthog",u.people=u.people||[],u.toString=function(t){var e="posthog";return"posthog"!==a&&(e+="."+a),t||(e+=" (stub)"),e},u.people.toString=function(){return u.toString(1)+".people (stub)"},o="init capture identify alias people set set_once reset get_property opt_in_capturing opt_out_capturing register register_once unregister".split(" "),n=0;n<o.length;n++)g(u,o[n]);e._i.push([i,s,a])},e.__SV=1)}(document,window.posthog||[]);
  /* eslint-enable */

  window.posthog.init(POSTHOG_KEY, {
    api_host: POSTHOG_HOST,
    person_profiles: 'identified_only',
  });

  window[POSTHOG_INIT_FLAG] = true;
}

/**
 * Loads and initializes Google Analytics 4 (gtag.js) ONLY when the user has granted
 * analytics consent. Same consent gate as PostHog, both are triggered together
 * from the cookie banner "accept" flow.
 */
function loadGA4() {
  if (typeof window === 'undefined') return;
  if (window[GA_INIT_FLAG]) return;

  // Inject the gtag.js loader (async)
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_MEASUREMENT_ID}`;
  document.head.appendChild(s);

  // Initialize dataLayer + gtag function
  window.dataLayer = window.dataLayer || [];
  // eslint-disable-next-line no-inner-declarations, prefer-rest-params
  function gtag() { window.dataLayer.push(arguments); }
  window.gtag = gtag;
  gtag('js', new Date());
  gtag('config', GA_MEASUREMENT_ID, {
    // IP anonymization is on by default in GA4; explicit flag for clarity
    anonymize_ip: true,
  });

  window[GA_INIT_FLAG] = true;
}

function hasAnalyticsConsent() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return false;
    const parsed = JSON.parse(raw);
    return parsed && parsed.analytics === true;
  } catch (e) {
    return false;
  }
}

function loadAnalyticsIfConsented() {
  if (!hasAnalyticsConsent()) return;
  loadPostHog();
  loadGA4();
}

function Analytics() {
  useEffect(() => {
    loadAnalyticsIfConsented();

    const onConsentChange = () => {
      loadAnalyticsIfConsented();
    };

    window.addEventListener('bpm-consent-changed', onConsentChange);
    window.addEventListener('storage', onConsentChange);

    return () => {
      window.removeEventListener('bpm-consent-changed', onConsentChange);
      window.removeEventListener('storage', onConsentChange);
    };
  }, []);

  return null;
}

export default Analytics;
